import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { AppService } from '../../../../app.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { TranslateService } from '../../../../translate';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../interpretation.service';
import { ActivatedRoute } from '@angular/router';
import { InterpretationOverviewModel, Condition, BarGraphView, AvailableInspectorsViewModel, ForwardAndReverseOptions, UpdateInspectionReadingBasedOnMeasurementClassModel, UpdateInspectionForwardAndReverseTravelModel, EquipmentModel, UpdateUnderFootConditionModel, UnderFootConditions, ComponentFlaggedVM, CopyInspection, ParentInspectionResponse, ParentInspection, ComponentComparison, AddiInspectorsOverviewModel, InspectionLocationVM } from '../../models/interpretation.model';
import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { ConditionCommentModalComponent } from '../../components/condition-comment-modal/condition-comment-modal.component';
import { BarGraphService } from '../../bar-graph.service';
import { QuoteService } from '../../quote-service.service';
import { SendReportModalComponent } from '../../components/send-report-modal/send-report-modal.component';
import { UserService } from '../../../../shared/services/user.service';
import { UpdateEvalModel } from '../../interpretation.model';
import { InspectionCommentModalComponent } from '../../components/inspection-comment-modal/inspection-comment-modal.component';
import { JobsiteCommentModalComponent } from '../../components/jobsite-comment-modal/jobsite-comment-modal.component';
import { PopupEndPoint } from '../../../inspection/models/create-inspection.model';
import { SetupUndercarriageService } from '../../../setup-undercarriage/setup-undercarriage.service';
import { TemperatureInspectionService } from '../../../../modules/Temperature/temperature-inspection.service';
import { TemperatureInspectionListVM } from '../../../../modules/Temperature/temperature-inspection.module';
import { AttachTemperatureInspectionPopupComponent } from '../../components/attach-temperature-inspection-popup/attach-temperature-inspection-popup.component';
import { CustomEvalService } from '../../../../modules/CustomEval/custom-eval.service';
import { CustomeEvaluationRangeVM } from '../../../../modules/CustomEval/custom-eval.model';
import { FrameConfigWarningComponent } from '../../components/frame-config-warning/frame-config-warning.component';
import { Observable, Subject } from 'rxjs';
import { ActionRecommendationRuleComponent } from '../../../Action-Recommendation/action-recommendation-rule/action-recommendation-rule.component';
import { ActionRecommendationRulesQuotesComponent } from '../../../Action-Recommendation/action-recommendation-attach-rules/action-recommendation-rule-quotes.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { ModelBaseObservations } from '../../../../../app/modules/setup-models/setup-models.model';
import { GeneralActionViewModel } from '../../../../../app/modules/action/action-models';
import { ActionService } from '../../../../../app/modules/action/action.service.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { CurrentSelection, Customer, Equipment, jobRolePermissions, JobSite, MenuListVM, Model, SearchItem, SelectionLists } from '../../../../../app/entities';
import { FormControl } from '@angular/forms';
import { SharedService } from '../../../../../app/shared/services/SharedService';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { EquipmentModelNew } from '../../../../../app/modules/manage-components/manage-components.model';
import { CryptoService } from '../../../../services/crypto.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EquipmentNotesHistoryComponent } from '../../../../shared/components/equipment-notes-history/equipment-notes-history.component';

/**
 * The interpretation component
 *
 */
@Component({
  selector: 'app-interpretation',
  templateUrl: './interpretation.component.html',
  styleUrls: ['./interpretation.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
  animations: [

    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger('fadeInList', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-5%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})


export class InterpretationComponent implements OnInit {
  private _userLanguage = 'english';
  private _subscriptions: Subscription[] = [];
  _inspectionId: number = -1;
  selectedTab = 0;
  Condition = Condition;
  ForwardAndReverseOptions = ForwardAndReverseOptions;
  UnderFootConditions = UnderFootConditions;
  oldUCUri = '';
  reportUri = '';
  selectedOption1: string = '';
  selectedOption2: string = '';
  selectedOption3: string = '';
  @Output() reloadSelectedQuotes: EventEmitter<any> = new EventEmitter();
  recommmendationID: number
  /*
    Overview Variables
  */
  overviewIsLoading = true;
  overviewModel: InterpretationOverviewModel = new InterpretationOverviewModel();
  overallEval = 'U';
  overallEvalLoading = true;
  systemIds: number[] = [];
  displayedColumns: string[] = ['RuleName', 'RuleDescripation', 'Add', 'components'];

  // Interp comment
  interpretationComment: string;
  loadingInterpretationComment = true;

  // Quote
  selectedQuoteId: number = -1;

  //Temperature
  selectedTemperatureId: number;
  // Bar Graphs
  smuInterval = 1000;
  barGraphView: BarGraphView = BarGraphView.Expanded;
  BarGraphView = BarGraphView;

  // Release
  releasing = false;

  // Has permission
  hasPermission = true;
  checkingForPermission = false;
  noPermissionReason = 'You are not authorized to view the interpretation page. ';
  isInterpreter = false;
  isInspector = false;
  isForecastOn = false;
  // Job comment
  jobsiteComment: string;
  loadingJobSiteComment = true;

  Family: string;
  FamilyId: number;
  FamilyImage_Chain: string;
  FamilyImage_Frame: string;

  measurementUnit = 'mm';
  measurementDistance = 'km';

  showUCCondition: boolean = true;

  observationListEndPoint: PopupEndPoint.ObservationListInterpretation;

  availableInspectors: AvailableInspectorsViewModel[] = [];
  overalComments_: EquipmentModel[] = [];


  impactvalue: number;
  abrasivevalue: number;
  moisturevalue: number;
  packingvalue: number;
  IsIndicatorRight: number = 1;
  //IsIndicatorLeft:boolean
  IsIndicatorLeft: number = 1;
  ToeOutFrameIncorrect: boolean
  EqualiserBarTypeComment: string
  IndicatorLeftComment: string
  IndicatorRightComment: string

  IndicatorLeftImage: string
  IndicatorRightImage: string
  EqualiserBarTypeImage: string


  equipmentID: number;
  EvalautionRange: CustomeEvaluationRangeVM;
  //Temperature Inspection
  hasTemInspection: boolean = false;
  TemperatureInspectionList: TemperatureInspectionListVM[] = [];
  IncludeTemp: boolean;

  userActivity;
  userInactive: Subject<any> = new Subject();

  TotalDistance: number;

  StartSMU: number;
  CurrentDate: Date = new Date();
  actionDate: Date;
  photoLoading = false;

  recordActionDate: Date;
  recordActionSMU: number;
  isParentChanged: boolean = false;

  //reloadRule: boolean;
  private userId = 1;
  savingForm: boolean;
  showCMU: boolean = true;
  showResLife100: boolean = true;
  showResLife120: boolean = true;
  showDOC: boolean = true;
  showResDOC100: boolean = true;
  showResDOC120: boolean = true;
  editComponentType: boolean = false;
  customerList: Customer[] = [];
  customerListFliter: Customer[] = [];
  CustomerId: number;
  public jobSiteList: JobSite[] = [];
  public jobSiteListFilter: JobSite[] = [];

  filteredCustomers: Observable<Customer[]>;
  filteredJobsites: Observable<JobSite[]>;
  filteredEquipments: Observable<Equipment[]>;
  filteredModels: Observable<Model[]>;
  selectionLists: SelectionLists = new SelectionLists();
  internalLimitedJobSites: JobSite[];
  internalLimitedEquipments: Equipment[];
  internalLimitedModels: Model[];
  internalLimitedCustomers: Customer[];
  customerCtrl: FormControl;
  jobsiteCtrl: FormControl;
  equipmentCtrl: FormControl;
  modelCtrl: FormControl;
  showTrackSag: boolean = false;
  showCannonExt: boolean = false;
  showScallop: boolean = false;
  showDryJoints: boolean = false;
  showNumberOfLinks: boolean = false;
  showUnderFootConditions: boolean = false;
  showWorkOrder: boolean = false;
  showThermalImages: boolean = false;
  IspopupOpen: boolean;
  enableEqualiserBar: boolean = false;
  isCondition: boolean = true;
  inspectionLocations: InspectionLocationVM[] = [];

  constructor(private _appService: AppService,
    private _loading: LoadingService,
    private _translate: TranslateService,
    private _ref: ChangeDetectorRef,
    private _notify: NotificationsService,
    private _interp: InterpretationService,
    private _route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _bar: BarGraphService,
    private _quotes: QuoteService,
    private _user: UserService,
    public dialog: MatDialog,
    private _setupService: SetupUndercarriageService,
    private _temperatureService: TemperatureInspectionService,
    private _evalService: CustomEvalService,
    private _actionService: ActionService, private _sharedService: SharedService,
    private _crypto: CryptoService
  ) {
    this._interp.getUserId().subscribe(r => this.userId = r, err => console.error(err));

    this.customerCtrl = new FormControl();
    this.jobsiteCtrl = new FormControl();
    this.equipmentCtrl = new FormControl();
    this.modelCtrl = new FormControl();
  }
  filterMakeModelFamilyForExistingOnly = true;
  DuplicateInspectionIsActive: string;
  ngOnInit() {
    this._inspectionId = this._route.snapshot.params.id;
    this.getInspectionLocations();
    this.CheckInspection()
    this.loadSelectedQuote();
    this._loading.startLoading();
    this._appService.setPageTitle('Interpretation');
    this._appService.getAppUris().subscribe(u => this.oldUCUri = u.oldUCUri);
    this._subscriptions.push(this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2)));

    this._user.checkDuplicateInspection().subscribe(result => {
      if (result != null) {
        this.DuplicateInspectionIsActive = result;
      }
    });

    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => {
      this.customerList = result;
      this.customerListFliter = result;
    });

    this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => {
      this.jobSiteList = result;
      this.jobSiteListFilter = result;
    });

    this._appService.getModelListForSelection(1, 10000).subscribe(result => {
      this.selectionLists.modelList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m);
      this.internalLimitedModels = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m); this.modelCtrl.reset();

      this.OpenPopup1();
    });

    this.LoadJobRoles();
    this.checkUserPermission();
    this.getReportUrl();

    this._loading.finishedLoading();
    this.setTimeout();
    this.userInactive.subscribe(() => console.log('user has been inactive for 3s'));

    this.filteredCustomers =
      this.customerCtrl.valueChanges
        .startWith(null)
        .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());
    this.filteredJobsites = this.jobsiteCtrl.valueChanges
      .startWith(null)
      .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());
    this.filteredModels =
      this.modelCtrl.valueChanges
        .startWith(null)
        .map(modelInput => modelInput ? this.filterModels(modelInput) : this.resetModel());



  }
  editorData: any;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    width: '100%',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'heading',
      ],
      [
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  }; userLanguage = 'english';
  MakeChangedMain(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(option => option.Unit.toLowerCase().includes(filterValue));
      // this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
      //     this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);

      this.filteredEquipments = Observable.of(this.internalLimitedEquipments);

    } else {

    }
  }
  closePopup() {
    this.IspopupOpen = false;
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  resetEquipment(): Equipment[] {
    // console.log('resetEquipment');
    this.currentSelection.equipment = new Equipment();
    if (!this.internalLimitedEquipments) return [];
    return this.internalLimitedEquipments.filter(equipment =>
      (this.multipleSelections.findIndex(m => m.Id === 3 && (m.SearchId === equipment.Id || m.SearchStr.toLowerCase() === equipment.Serial.toLowerCase())) < 0)
    );
  }
  filterEquipments(userText: any) {
    let txt = '';
    if (userText.Serial)
      txt = userText.Serial;
    else txt = userText;

    return this.internalLimitedEquipments.filter(equipment =>
      ((equipment.Serial.toLowerCase().indexOf(txt.toLowerCase()) === 0) || (equipment.Unit.toLowerCase().indexOf(txt.toLowerCase()) === 0)
        || (equipment.AddiUnit && (equipment.AddiUnit.toLowerCase().indexOf(txt.toLowerCase()) === 0)))
      && (this.multipleSelections.findIndex(m => m.Id === 3 && (m.SearchId === equipment.Id || m.SearchStr.toLowerCase() === equipment.Serial.toLowerCase() ||
        m.SearchStr.toLowerCase() === equipment.AddiUnit.toLowerCase())) < 0)
    );

  }
  JobsiteId: number;
  ModelId: number;
  OpenPopup1() {
    //this.IspopupOpen = true;

    if (this.customerList.length > 0) {
      this.CustomerId = this.customerList.find(x => x.Title == this.overviewModel.Equipment.CustomerName).Id;
    }

    if (this.jobSiteList.length > 0) {
      this.JobsiteId = this.jobSiteList.find(x => x.Title == this.overviewModel.Equipment.JobsiteName).Id;
    }
    this.modelCtrl.setValue(this.overviewModel.Equipment.Model);
    this.ModelId = this.selectionLists.modelList.find(x => x.Title == this.overviewModel.Equipment.Model).Id;
    this.GetEquipment()

  }

  OpenPopup() {
    this.IspopupOpen = true;
  }
  selectedJobsiteForInput: JobSite = new JobSite();
  pushMultipleSelection(itemId: number, searchId: number, searchText: string): void {

    if ((searchId === 0 && searchText.length === 0))
      return;
    console.log('itemId ' + itemId + '  search Id ' + searchId + ' searvh text ' + searchText)
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;

    // If the item isn't a date
    if (itemId !== 12 && itemId !== 13 && itemId !== 22 && itemId !== 23) {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
      if (index >= 0 && itemId !== 20) return;
    } else if (itemId == 22) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 22);
    }
    else if (itemId == 23) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 23);
    }
    else {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId);
      this.multipleSelections.splice(index, 1);
    }
    const item = new SearchItem();
    item.Id = itemId; item.SearchId = searchId; item.SearchStr = searchText; item.Title = searchText;

    if (itemId == 1) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 2) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 4) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 5) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    }
    else {
      this.multipleSelections.push(item);
    }


    console.log("this.multiple__", this.multipleSelections, item)
  }
  JobSiteforFleetconfiguration: JobSite = new JobSite()
  jobsiteSelected(selected, input) {
    // console.log('jobsiteSelected', selected);
    this.selectedJobsiteForInput.Id = selected.option.value.Id
    this.currentSelection.jobSite.Id = selected.option.value.Id;
    this.currentSelection.jobSite.Title = selected.option.value.Title;
    this.pushMultipleSelection(2, selected.option.value.Id, selected.option.value.Title);
    this.JobSiteforFleetconfiguration.Id = selected.option.value.Id
    this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);

    this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
      this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
    this.filteredEquipments = Observable.of(this.internalLimitedEquipments);


    var customerData = this.multipleSelections.find(x => x.Id == 1);
    let customerid = 0;
    if (customerData != null) {
      customerid = customerData.SearchId;
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    let jobsiteid = 0;
    if (jobSiteData != null) {
      jobsiteid = jobSiteData.SearchId;
    }
    this.jobsiteCtrl.reset();
    this.jobsiteCtrl.setValue(selected.option.value.Title);
  }
  resetModel(): Model[] {
    this.currentSelection.model = new Model();


    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model =>
      this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);
  }
  @ViewChild('customerAutoCompleteInput', { read: MatAutocompleteTrigger })
  customerTrigger: MatAutocompleteTrigger;
  @ViewChild('jobSiteAutoCompleteInput', { read: MatAutocompleteTrigger })
  jobSiteTrigger: MatAutocompleteTrigger;
  @ViewChild('equipmentAutoCompleteInput', { read: MatAutocompleteTrigger })
  equipmentTrigger: MatAutocompleteTrigger;
  @ViewChild('makeAutoCompleteInput', { read: MatAutocompleteTrigger })
  makeTrigger: MatAutocompleteTrigger;
  @ViewChild('modelAutoCompleteInput', { read: MatAutocompleteTrigger })
  modelTrigger: MatAutocompleteTrigger;


  focus(item) {
    switch (item) {
      case 1:
        this.customerTrigger.openPanel();
        break;
      case 2:
        this.jobSiteTrigger.openPanel();
        break;
      case 3:
        this.equipmentTrigger.openPanel();
        break;
      case 6:
        this.modelTrigger.openPanel();
        break;

    }
  }

  customerSelected(selected, input) {
    // console.log('customerSelected', selected);

    this.selectedJobsiteForInput.CustomerId = selected.option.value.Id
    this.currentSelection.customer.Id = selected.option.value.Id;
    this.currentSelection.customer.Title = selected.option.value.Title;
    //fleet configuration filter
    this.JobSiteforFleetconfiguration.CustomerId = selected.option.value.Id;
    //this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);
    this.pushMultipleSelection(1, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);

    this.customerCtrl.reset();
    this.customerCtrl.setValue(selected.option.value.Title)
  }
  separatorKeysCodes: number[] = [ENTER, COMMA];
  equipmentSelected(selected, input) {
    console.log('equipmentSelected', selected);

    if (input)
      input.value = '';
    this.currentSelection.equipment.Id = selected.option.value.Id;
    this.currentSelection.equipment.Serial = selected.option.value.Unit;
    this.pushMultipleSelection(3, selected.option.value.Id, selected.option.value.Unit);
    this.equipmentCtrl.reset();
    this.equipmentCtrl.setValue(selected.option.value.Unit);
  }
  modelSelected(selected, input) {

    if (input)
      input.value = '';
    this.currentSelection.model.Id = selected.option.value.Id;
    this.currentSelection.model.Title = selected.option.value.Title;
    this.pushMultipleSelection(6, selected.option.value.Id, selected.option.value.Title);
    this.modelCtrl.reset();
    this.modelCtrl.setValue(selected.option.value.Title);
  }
  filterModels(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      );

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);


    return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
      && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

  }
  filterCustomers(userText: any) {
    // console.log('filterCustomers', userText);
    let txt = '';


    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.selectionLists.customerList.filter(cust =>
      cust.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }
  currentSelection: CurrentSelection = new CurrentSelection();
  multipleSelections: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: 'Evaluation X' }];

  resetCustomer(): Customer[] {
    // console.log('resetCustomer');
    this.currentSelection.customer = new Customer();
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
    this.jobsiteCtrl.reset();

    // return this.selectionLists.customerList.filter(cust =>
    //     (this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr.toLowerCase() === cust.Title.toLowerCase())) < 0)
    // );

    if (this.multipleSelections.filter(m => m.Id === 21).length === 0)
      return this.selectionLists.customerList.filter(cust => this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 21).length > 0)
      return this.selectionLists.customerList.filter(cust =>
        this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);

    return this.selectionLists.customerList.filter(cust =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);


  }

  resetJobsite(): JobSite[] {
    // console.log('resetJobsite', this.internalLimitedJobSites);
    this.currentSelection.jobSite = new JobSite();
    if (!this.internalLimitedJobSites) return [];

    this.equipmentCtrl.reset();
    return this.internalLimitedJobSites.filter(jobsite =>
      (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
    );
  }
  filterJobsites(userText: any) {
    // console.log('filterJobsites', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.internalLimitedJobSites.filter(jobsite =>
      jobsite.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }

  getReportUrl() {
    this._appService.getApplicationConfigValue("ReportDirectory").subscribe(result => {
      this.reportUri = result.replace("/GSNetImages", "");
    });
  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 3000);
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }
  /**
   * Starts loading all the inspection data. This will be called once it is confirmed
   * that the user has permission to view this inspection.
   */
  initializePage() {
    console.log("initializePage....", true);
    this.loadOverview();
    //this.loadOverallEval();
    this.loadSystemIds();
    this.initializeGraphs();
    this.loadInterpretationComment();
    this.LoadFlaggedComponents();
    this.loadPreferences();
  }
  loadAvailableInspectors() {
    // console.log("this.overviewModel",this.overviewModel)
    //console.log("this.overviewModel.Equipment.EquipmentId",this.overviewModel.Equipment.EquipmentId)
    this._interp.getAvailableInspectorsBasedOnEquipment(this.overviewModel.Equipment.EquipmentId).subscribe(r => {
      // console.log("availableInspectors",r)

      this.availableInspectors = r;
      //AES256
      this.availableInspectors.forEach((insp: any) => {
        if (insp?.UserName && insp.UserName.length > 0) {
          insp.UserName = this._crypto.decrypt(insp.UserName);
        }
      });
    });
  }
  loadPreferences() {
    this._interp.GetUserPreferences().subscribe(r => {
      if (r !== undefined && r !== null && r !== 'mm')
        this.measurementUnit = 'Inches';
    });
    this._interp.GetUserPreferencesDistance().subscribe(r => {
      if (r !== undefined && r !== null)
        this.measurementDistance = r;
    });

    this._interp.GetUserPreferenceUCConditon().subscribe(r => {
      if (r == '1')
        this.showUCCondition = true;
      else this.showUCCondition = false;
    });

  }

  /**
   * Checks that the user has permission to view the page.
   */
  checkUserPermission() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case 'Customer Admin':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
            case 'Customer Admin':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
            case 'Undercarriage ONLY':
            case 'Undercarriage Inspector ONLY':
              this.isInspector = true;
              break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
    this._interp.checkPermission(this._inspectionId).subscribe(r => {
      if (r.m_Item1) {
        this.hasPermission = true;
        this.initializePage();
      } else {
        this.hasPermission = false;
        this.noPermissionReason = r.m_Item2;
      }
      this.checkingForPermission = false;
    }, err => {
      this._notify.warn('No Access', 'You do not have permission to view this page. ');
    });
  }

  /**
   * Gets the url link to the edit inspection page, passing in
   * the current inspection as a parameter.
   * @returns The inspection url
   */
  get editInspectionUrl(): string {
    return this.oldUCUri + 'Track/UndercarriageInspection.aspx?inspect=' + this._inspectionId;
  }

  openSendReport() {
    const ref = this._dialog.open(SendReportModalComponent, {
      data: {
        inspectionId: this._inspectionId,
        selectedQuoteId: this.selectedQuoteId,
        selectedTemperatureId: this.overviewModel.TempInspectionId,
        equipment_id: this.overviewModel.Equipment.EquipmentId,
        InspectorName: this.overviewModel.InspectorName
      }
    });
  }

  setBarGraphView(view: BarGraphView) {
    this._bar.setBarGraphView(view);
  }

  zoomInBarGraph() {
    this._bar.increaseZoomScale();
  }

  zoomOutBarGraph() {
    this._bar.decreaseZoomScale();
  }

  setBarGraphInterval(interval: number) {
    this._bar.setSmuInterval(interval);
  }

  initializeGraphs() {
    this._bar.getSmuInterval().subscribe(interval => this.smuInterval = interval);
    this._bar.getBarGraphView().subscribe(view => this.barGraphView = view);
  }

  selectedQuoteIdChanged(quoteId: number) {
    // console.log('selected quoteId ' + quoteId);
    this.selectedQuoteId = quoteId;
    //this.reloadRule = true;
  }

  reloadQuotes(event) {
    this.selectedQuoteIdChanged(event.quoteId);
    this.selectedQuoteId = event.quoteId
    this.recommmendationID = event.recommendationId;

  }

  get pdfReportUrl(): string {
    return this.oldUCUri + 'track/gettracktreadspdfreport.aspx?quoteAuto=' + this.selectedQuoteId + '&temperatureId=' + this.selectedTemperatureId;
  }

  get telerikPdfReportUrl(): string {
    return this.reportUri + 'Report.aspx?quoteAuto=' + this.selectedQuoteId + '&ud=' + this.userId;
  }

  downloadTelerikPdf() {

    if (this.selectedQuoteId < 1)
      this.addQuote(false, true);
    //if temp and quote true
    else {
      this.savingForm = true;
      this._quotes.CheckInspectionHasBeenReleasedYet(this._inspectionId, this.selectedQuoteId).subscribe(r => {
        if (r) {

          //window.open(this.telerikPdfReportUrl, '_blank');
          //window.open(this._appService.getBaseURL() + 'api/Interpretation/DownloadQuotePDF?Inspectionid=' + this._inspectionId.toString() + '&QuoteId=' + this.selectedQuoteId.toString(), '_blank');
          this._quotes.downloadQuotePDF(this._inspectionId, this.selectedQuoteId)
            .subscribe(response => {
              const blob = response.body as Blob;
              // Get filename from header
              const contentDisposition = response.headers.get('content-disposition');
              let fileName = 'Interpretation.pdf'; // fallback
              if (contentDisposition) {
                const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
                if (matches && matches[1]) {
                  fileName = matches[1];
                }
              }
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
              this.savingForm = false;
            });

        } else {
          this._notify.error('Error', 'Please release this quote report first ');
          this.savingForm = false;
        }
      });
    }
  }

  firstload: boolean = true;
  ReloadPage() {
    //console.log("reload")
    if (this.selectedTab == 1) {
      this.firstload = false;
    } else if (this.selectedTab == 0 && this.firstload == false) {
      window.location.reload();

    }
  }
  downloadPdf() {

    if (this.selectedQuoteId < 1)
      this.addQuote(false, true);
    //if temp and quote true
    else {
      this._quotes.CheckInspectionHasBeenReleasedYet(this._inspectionId, this.selectedQuoteId).subscribe(r => {
        if (r) {
          window.open(this.pdfReportUrl, '_blank');
        } else {
          this._notify.error('Error', 'Please release this quote report first ');
        }
      });
    }

    // if (this.selectedTemperatureId > 0) {
    //   this.openAttachedTemperature();
    // } else {
    //   if (this.selectedQuoteId < 1)
    //     this.addQuote(false, true);
    //   //if temp and quote true
    //   else {
    //     this._quotes.CheckInspectionHasBeenReleasedYet(this._inspectionId, this.selectedQuoteId).subscribe(r => {
    //       if (r) {
    //         window.open(this.pdfReportUrl, '_blank');
    //       } else {
    //         this._notify.error('Error', 'Please release this quote report first ');
    //       }
    //     });
    //   }
    // }

  }

  /**
   * All quotes are added through the quote container component. I
   * need this function here for releasing a report. If there are no
   * quotes created yet, we will create one then release it. Because
   * at least 1 quote needs to exist.
   */
  addQuote(callReleaseReport: boolean = false, callDownloadPdf: boolean = false) {
    this._interp.addQuote(this._inspectionId).subscribe(r => {
      if (r.m_Item1 > 0) {
        this.selectedQuoteIdChanged(r.m_Item1);
        if (callReleaseReport)
          this.callReleaseReportApi();
        else if (callDownloadPdf)
          this.downloadPdf();
        this._quotes.reloadQuoteOverview(this._inspectionId);
      } else {
        this._notify.error('Error', 'Failed to add a new quote which is required to release the inspection. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Error', 'Failed to add a new quote which is required to release the inspection. Please contact TrackTreads support. ');
      console.error(err);
    });
  }

  callReleaseReportApi() {
    this._interp.releaseReport(this._inspectionId, this.selectedQuoteId).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Released', r.m_Item2);
        this.overviewModel.Released = true;
        //console.log("callReleaseReportApi....", true);
        this.loadOverview();
        this.releasing = false;
      } else {
        this._notify.error('Failed', 'Unable to release report. Contact TrackTreads support for help. ');
        this.releasing = false;
      }
    }, err => {
      console.error(err);
      this._notify.error('Failed', 'Unable to release report. Contact TrackTreads support for help. ');
      this.releasing = false;
    });
  }
  openWarningTracFrameConfig(): void {
    const dialogRef = this.dialog.open(FrameConfigWarningComponent, {
      disableClose: true,
      width: '1032px',
      data: {
        inspectionId: this._inspectionId
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.overviewModel.hasFrameConfigFlag == false;
      }
    });

  }
  releaseReport() {

    this._interp.checkTrackFrameFlag(this._inspectionId).subscribe(res => {
      
      if (res == true) {
        this.openWarningTracFrameConfig();
      } else {
        if (this.releasing)
          return;
        this.releasing = true;
        if (this.selectedQuoteId < 1)
          this.addQuote(true, false);
        else
          this.callReleaseReportApi();
      }
    })
    // console.log("FLAGGGG_FUCK++", this.Flagon, this.overviewModel.hasFrameConfigFlag)
    // //check has flag on track INspection //TT-2682
    // if(this.Flagon==true){
    //   //open pop up
    //   this.openWarningTracFrameConfig();

    // }else{

    // }


  }


  changedInspector(changedToInspector) {
    this._loading.startLoading();
    this._interp.changeInspectionsInspector(this._inspectionId, changedToInspector.UserId).subscribe(r => {
      if (r) {
        this._notify.success(`Successfully changed inspector to ${changedToInspector.UserName}`);
        this.overviewModel.InspectorName = changedToInspector.UserName;
      } else {
        this._notify.error(`Failed to change inspector`);
      }
      this._loading.finishedLoading();
    });
  }

  updateOverallEval(evaluation: string) {
    //console.log("updateOverallEval",this.overallEval)
    this._loading.startLoading();

    const updatModel = new UpdateEvalModel();
    updatModel.inspectionId = this._inspectionId;
    updatModel.newEval = evaluation;
    this._interp.setOverallEval(updatModel).subscribe(r => {
      if (r.m_Item1) {
        this.overallEval = evaluation;
        this._notify.success('Saved', r.m_Item2);
        this._loading.finishedLoading();
      } else {
        this._notify.error('Error', r.m_Item2);
        this._loading.finishedLoading();
      }
    }, err => this.handleError(err, 'Can\'t update the overall eval. '));
  }

  childMeasurementPointUpdated() {
    console.log("childMeasurementPointUpdated....", true);
    this.loadOverview();
    this.loadOverallEval();
  }


  ComponentCommentUpdated() {
    this.loadInterpretationComment();
  }

  updateImage(data) {
    //console.log("updateImage....", true);
    this.loadOverview();
  }



  updateForwardReverseReadings(newReading, option: ForwardAndReverseOptions) {

    //console.log(newReading , option.toString());
    this._loading.startLoading();
    const model = new UpdateInspectionForwardAndReverseTravelModel();
    model.InspectionId = this._inspectionId;
    model.NewReading = newReading;
    model.ForwardAndReverseOptions = option;
    model.uod = this.measurementDistance;
    this._interp.UpdateForwardAndReverseReading(model).subscribe(r => {
      this._interp.getInterpretationOverview(this._inspectionId).subscribe(overview => {
        this.overviewModel = overview;
        this.overviewModel.InspectorName = this._crypto.decrypt(overview.InspectorName);
        this.TotalDistance = (this.overviewModel.Equipment.ForwardTravelKM == null ? 0 : this.overviewModel.Equipment.ForwardTravelKM) + (this.overviewModel.Equipment.ReverseTravelKM == null ? 0 : this.overviewModel.Equipment.ReverseTravelKM);
        this._loading.finishedLoading();
        if (r.m_Item1) {
          this._notify.success(ForwardAndReverseOptions[option] + ' readings has been successfully updated');
        } else {
          this._notify.error('Fail to update ' + ForwardAndReverseOptions[option] + ' reading');
        }
      });


    });
    // ForwardTravelKm,
    // ReverseTravelKm,



  }

  updateUnderFootConditions(option: UnderFootConditions) {
    const model = new UpdateUnderFootConditionModel();
    model.InspectionId = this._inspectionId;
    model.Impact = this.impactvalue;
    model.Abrasive = this.abrasivevalue;
    model.Moisture = this.moisturevalue;
    model.Packing = this.packingvalue;
    model.ToeOutFrameIncorrect = this.ToeOutFrameIncorrect
    model.IsIndicatorLeft = Boolean(this.IsIndicatorLeft);
    model.IsIndicatorRight = Boolean(this.IsIndicatorRight)
    model.UnderFootConditionOptions = option;
    this._interp.UpdateUnderFootConditions(model).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success(UnderFootConditions[option] + ' Conditions has been successfully updated');
      } else {
        this._notify.error('Fail to update ' + UnderFootConditions[option] + +' Conditions');
      }
    });
  }

  changeEvalInChildClicked(data) {
    this.updateOverallEval(data);
  }


  LoadTemperatureInspectionsForEquipment() {
    this._temperatureService.LoadTemperatureInspectionForInterp(this.overviewModel.Equipment.EquipmentId, this.overviewModel.TempInspectionId).subscribe(res => {
      this.TemperatureInspectionList = res;
      console.log("TemperatureInspectionList", this.TemperatureInspectionList)

      // if(this.TemperatureInspectionList.length>0){
      //     //this.hasTemperatureInspection=true;

      //     if(this.overviewModel!=null){
      //           this.TemperatureInspectionList.map(y=>{
      //               let idate = new Date(this.overviewModel.InspectionDate)
      //               let tdate = new Date(y.InspectionSummary.InspectionDate)
      //               if(idate.getTime() == tdate.getTime()){
      //                  this.hasTemInspection =true;
      //               }
      //           })

      //   }

      //   }



    })
  }
  loadSelectedQuote() {
    this._interp.getInterpretationSelectedQuoteId(this._inspectionId).subscribe(QuoteId => {
      this.selectedQuoteId = QuoteId;
    });
  }

  Flagon: boolean = false;

  showCRoller: boolean = false;
  observationInfo: ModelBaseObservations[] = [];
  hasCRoller: boolean = false;
  worstWornLeft: number;
  worstWornRight: number;
  worstEvalLeft: string;
  worstEvalRight: string;
  loadOverview() {
    this._interp.getInterpretationOverview(this._inspectionId).subscribe(overview => {
      this.overviewModel = overview;
      this.overviewModel.InspectorName = this._crypto.decrypt(overview.InspectorName);
      console.log("overviewModel", this.overviewModel);
      console.log("isInspector", this.isInspector);
      this.equipmentID = this.overviewModel.Equipment.EquipmentId;
      this.impactvalue = this.overviewModel.Equipment.ImpactValue;
      this.isForecastOn = this.overviewModel.Equipment.ForecastId == 1 ? true : false;
      this.abrasivevalue = this.overviewModel.Equipment.AbrasiveValue;
      this.moisturevalue = this.overviewModel.Equipment.MoistureValue;
      this.packingvalue = this.overviewModel.Equipment.PackingValue;


      //getting the new comment
      this.EqualiserBarTypeComment = this.overviewModel.Equipment.EqualiserBarTypeComment;
      this.IndicatorLeftComment = this.overviewModel.Equipment.IndicatorLeftComment;
      this.IndicatorRightComment = this.overviewModel.Equipment.IndicatorRightComment;

      //getting the Image
      this.IndicatorLeftImage = this.overviewModel.Equipment.IndicatorLeftImage;
      this.IndicatorRightImage = this.overviewModel.Equipment.IndicatorRightImage;
      this.EqualiserBarTypeImage = this.overviewModel.Equipment.EqualiserBarTypeImage;
      this.IsIndicatorLeft = Number(this.overviewModel.Equipment.IsIndicatorLeft);
      this.IsIndicatorRight = Number(this.overviewModel.Equipment.IsIndicatorRight);
      this.ToeOutFrameIncorrect = this.overviewModel.Equipment.ToeOutFrameIncorrect;

      this.enableEqualiserBar = this.overviewModel.Equipment.EnableEqualiserBar;
      this.isCondition = this.overviewModel.Equipment.IsCondition;
      //getting radioButton 

      //getting the radio button
      this.selectedTemperatureId = this.overviewModel.TempInspectionId;
      this.overallEval = this.overviewModel.EvalCode;
      this.showCRoller = this.overviewModel.Equipment.ShowHideCRoller;
      //this.selectedQuoteId = this.overviewModel.ReleasedQuoteId;
      this.TotalDistance = (this.overviewModel.Equipment.ForwardTravelKM == null ? 0 : this.overviewModel.Equipment.ForwardTravelKM) + (this.overviewModel.Equipment.ReverseTravelKM == null ? 0 : this.overviewModel.Equipment.ReverseTravelKM);
      this.observationInfo = this.overviewModel.observationInfo;
      this.hasCRoller = this.overviewModel.hasCRoller;
      this.worstWornLeft = this.overviewModel.Equipment.WorstWornL;
      this.worstWornRight = this.overviewModel.Equipment.WorstWornR;
      this.worstEvalLeft = this.overviewModel.Equipment.WorstEvalL;
      this.worstEvalRight = this.overviewModel.Equipment.WorstEvalR;

      this.borderClassSL = this.GetBorderColour(this.overviewModel.Equipment.ScallopL, 'S');
      this.borderClassSR = this.GetBorderColour(this.overviewModel.Equipment.ScallopR, 'S');
      this.borderClassCEL = this.GetBorderColour(this.overviewModel.Equipment.CannonExtL, 'CE');
      this.borderClassCER = this.GetBorderColour(this.overviewModel.Equipment.CannonExtR, 'CE');
      this.borderClassTSL = this.GetBorderColour(this.overviewModel.Equipment.TrackSagL, 'TS');
      this.borderClassTSR = this.GetBorderColour(this.overviewModel.Equipment.TrackSagR, 'TS');


      if (this.overviewModel.hasFrameConfigFlag == true) {
        this.Flagon = true;
      } else {
        this.Flagon = false;
      }
      //console.log(this.overviewModel.Equipment);
      //console.log("loadOverview",this.overallEval)
      if (this.overviewModel.TempInspectionId > 0) {
        this.LoadTemperatureInspectionsForEquipment();
      }
      this.loadAvailableInspectors();
      //console.log(this.overviewModel, 'overviewModel');
      this.Family = this.overviewModel.Equipment.Family;
      this.FamilyId = this.overviewModel.Equipment.FamilyId;
      this.getFamilyDetails(this.Family, this.FamilyId);
      this.checkDecimalValues();
      this.LoadEvalautionForEquipment();
      this._appService.setPageTitle('Interpretation | ' + overview.Equipment.SerialNumber + ' : ' + new Date(overview.InspectionDate).toDateString());
      this.overviewIsLoading = false;
    }, err => this.handleError(err, 'Can\'t find this interpretation. '));


  }

  LoadEvalautionForEquipment() {
    this._evalService.GetSelectedLevelRangesForSelectedEquipment(this.equipmentID).subscribe(res => {
      this.EvalautionRange = res;
    })
  }
  checkDecimalValues() {
    let splitTrackSagL = this.overviewModel.Equipment.TrackSagL;
    let sagL = splitTrackSagL.split('.');
    if (sagL[1] === '000') {
      this.overviewModel.Equipment.TrackSagL = sagL[0];
    }
    let splitTrackSagR = this.overviewModel.Equipment.TrackSagR;
    let sagR = splitTrackSagR.split('.');
    if (sagR[1] === '000') {
      this.overviewModel.Equipment.TrackSagR = sagR[0];
    }
    let CannonR = this.overviewModel.Equipment.CannonExtR;
    let canR = CannonR.split('.');
    if (canR[1] === '000') {
      this.overviewModel.Equipment.CannonExtR = canR[0];
    }
    let CannonL = this.overviewModel.Equipment.CannonExtL;
    let canL = CannonL.split('.');
    if (canL[1] === '000') {
      this.overviewModel.Equipment.CannonExtL = canL[0];
    }
    let SacllopR = this.overviewModel.Equipment.ScallopR;
    let scalR = SacllopR.split('.');
    if (scalR[1] === '000') {
      this.overviewModel.Equipment.ScallopR = scalR[0];
    }
    let SacllopL = this.overviewModel.Equipment.ScallopL;
    let scalL = SacllopL.split('.');
    if (scalL[1] === '000') {
      this.overviewModel.Equipment.ScallopL = scalL[0];
    }
    let DryJointL = this.overviewModel.Equipment.DryJointsL;
    let dryL = DryJointL.split('.');
    if (dryL[1] === '000' || dryL[1] !== '000') {
      this.overviewModel.Equipment.DryJointsL = dryL[0];
    }
    let DryJointR = this.overviewModel.Equipment.DryJointsR;
    let dryR = DryJointR.split('.');
    if (dryR[1] === '000' || dryR[1] !== '000') {
      this.overviewModel.Equipment.DryJointsR = dryR[0];
    }




  }
  loadInterpretationComment() {
    this._interp.getOverallInterpretationComment(this._inspectionId).subscribe(overallComment => {
      this.interpretationComment = overallComment;
      this.loadingInterpretationComment = true;
    }, err => this.handleError(err, 'Can\'t get the interpretation comment. '));
  }

  updateInterpretationComment(newComment: string) {
    this._loading.startLoading();
    this._interp.setOverallInterpretationComment(this._inspectionId, this.interpretationComment).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
        this._loading.finishedLoading();
      } else {
        this._notify.error('Error', r.m_Item2);
        this._loading.finishedLoading();
      }
    }, err => {
      this._notify.error('Error', 'Unable to save the interpretation comment. Please contact TrackTreads support. ');
      console.error(err);
      this._loading.finishedLoading();
    });
  }

  openAttachedTemperature() {
    const viewattacheTemperatureRef = this._dialog.open(AttachTemperatureInspectionPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
      }
    });
    viewattacheTemperatureRef.afterClosed().subscribe(result => {
      if (result) {
        this.IncludeTemp = true;
        if (this.selectedQuoteId < 1)
          this.addQuote(false, true);
        //if temp and quote true
        else {
          this._quotes.CheckInspectionHasBeenReleasedYet(this._inspectionId, this.selectedQuoteId).subscribe(r => {
            if (r) {
              window.open(this.pdfReportUrl, '_blank');
            } else {
              this._notify.error('Error', 'Please release this quote report first ');
            }
          });
        }
      }
      else {
        this.IncludeTemp = false;
        if (this.selectedQuoteId < 1)
          this.addQuote(false, true);
        //if temp and quote true
        else {
          this._quotes.CheckInspectionHasBeenReleasedYet(this._inspectionId, this.selectedQuoteId).subscribe(r => {
            if (r) {
              window.open(this.pdfReportUrl, '_blank');
            } else {
              this._notify.error('Error', 'Please release this quote report first ');
            }
          });
        }
      }

    });
  }
  openConditionComment(condition: Condition, comment: string) {
    const viewCommentModalRef = this._dialog.open(ConditionCommentModalComponent, {
      width: '1032px',
      data: {
        inspectionId: this._inspectionId,
        condition: condition,
        comment: comment
      }
    });
    viewCommentModalRef.afterClosed().subscribe(reloadComment => {
      if (reloadComment)
        this.loadOverview();
    });
  }
  borderClassCEL: string = ''
  borderClassCER: string = ''
  borderClassSR: string = ''
  borderClassSL: string = ''
  borderClassTSL: string = ''
  borderClassTSR: string = ''
  updateReadings(value, condition: Condition, type: string) {
    this._loading.startLoading();
    this._interp.UpdateInspectionReadingBasedOnMeasurementClass(value, condition, this._inspectionId).subscribe(r => {
      this._loading.finishedLoading();
      if (r.m_Item1) {
        this._notify.success(r.m_Item2);
        if (type == 'CE_L')
          this.borderClassCEL = this.GetBorderColour(value, "CE");
        if (type == 'CE_R')
          this.borderClassCER = this.GetBorderColour(value, "CE");

        if (type == 'S_L')
          this.borderClassSL = this.GetBorderColour(value, "S");
        if (type == 'S_R')
          this.borderClassSR = this.GetBorderColour(value, "S");

        if (type == 'TS_L')
          this.borderClassTSL = this.GetBorderColour(value, "TS");
        if (type == 'TS_R')
          this.borderClassTSR = this.GetBorderColour(value, "TS");

      } else {
        this._notify.error(r.m_Item2);
      }
    });
  }




  loadOverallEval() {
    this._interp.getOverallEval(this._inspectionId).subscribe(overallEval => {
      this.overallEval = overallEval;
      this.overallEvalLoading = false;
    }, err => this.handleError(err, 'Can\'t get the overall evaluation. '));
  }

  loadSystemIds() {
    this._interp.getSystemIds(this._inspectionId).subscribe(systems => {
      this.systemIds = systems;
    });
  }


  // sendToParent(data) {
  //     if(data){
  //       this.loadSystemIds();  
  //       this.loadOverview();
  //     }
  //   }

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }

  updateUserLang(lang: string) {
    this._userLanguage = lang;
    this._ref.detectChanges();
  }

  translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }

  handleError(error, message: string) {
    this._notify.error('Error', message);
    this._loading.finishedLoading();
  }

  // sanitize(image: string) {
  //   return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  // }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  getFamilyDetails(value: string, familyId: number) {
    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        let familydetails = res
        familydetails.map(x => {
          if (x.typedesc == value) {
            this.FamilyImage_Chain = x.ChainImage
            this.FamilyImage_Frame = x.FrameImage
          }
        })
        if (familydetails?.length) {

          const family = familydetails.find(
            f => f.type_auto === familyId
          );

          if (family) {
            this.showTrackSag = family.ShowTrackSag;
            this.showCannonExt = family.ShowCannonExt;
            this.showScallop = family.ShowScallop;
            this.showDryJoints = family.ShowDryJoints;
            this.showNumberOfLinks = family.ShowNumberOfLinks;
            this.showUnderFootConditions = family.ShowUnderFootConditions;
            this.showWorkOrder = family.ShowWorkOrder;
            this.showThermalImages = family.ShowThermalImage;
          }
        }

      }
    })
  }

  isEditingWorkOrder = false;

  enableWorkOrderEdit() {
    this.isEditingWorkOrder = true;
  }

  disableWorkOrderEdit() {
    this.isEditingWorkOrder = false;

    // OPTIONAL:
    // call API to save updated work order here
    // this.saveWorkOrder(this.overviewModel.WorkOrder);

    this._interp.addOrUpdateWorkOrder({
      InspectionId: this.overviewModel.InspectionId,
      WorkOrder: this.overviewModel.WorkOrder
    }).subscribe(res => {
      if (res.m_Item1) {
        this._notify.success('Saved', res.m_Item2);
        this.isEditingWorkOrder = false;
      }
    });
  }

  isEditingLocation = false;

  enableLocationEdit() {
    this.isEditingLocation = true;
  }

  disableLocationEdit() {
    this.isEditingLocation = false;
    //this._interp.addOrUpdateWorkOrder({
    //  InspectionId: this.overviewModel.InspectionId,
    //  WorkOrder: this.overviewModel.WorkOrder
    //}).subscribe(res => {
    //  if (res.m_Item1) {
    //    this._notify.success('Saved', res.m_Item2);
    //    this.isEditingLocation = false;
    //  }
    //});
  }

  openInspectionCommentDialog(comment: string): void {
    const dialogRef = this.dialog.open(InspectionCommentModalComponent, {
      width: '1032px',
      data: {
        inspectionId: this._inspectionId,
        comment: comment
      },

    });
    dialogRef.afterClosed().subscribe(reloadComment => {
      if (reloadComment)
        this.loadOverview();
    });

  }

  openJobsiteCommentDialog(comment: string): void {
    const dialogRef = this.dialog.open(JobsiteCommentModalComponent, {
      width: '1032px',
      data: {
        inspectionId: this._inspectionId,
        comment: comment
      },

    });
    dialogRef.afterClosed().subscribe(reloadComment => {
      if (reloadComment)
        this.loadOverview();
    });

  }

  openAddRecommendation() {
    const addRecommendationModalRef = this._dialog.open(ActionRecommendationRuleComponent, {
      data: {
        inspectionId: this._inspectionId,
        componentId: 0,
        quoteId: this.selectedQuoteId,
      }
    });
  }

  openRecommendation() {
    if (this.actionDate == undefined || this.actionDate == null) {
      this._notify.error('Alert', 'Please select Date!!');
    }
    else if (this.StartSMU == undefined || this.StartSMU == 0) {
      this._notify.error('Alert', 'Please enter SMU!!');
    }
    else {
      const addRecommendationModalRef = this._dialog.open(ActionRecommendationRulesQuotesComponent, {
        data: {
          inspectionId: this._inspectionId,
          componentId: 0,
          quoteId: this.selectedQuoteId,
          StartSMU: this.StartSMU,
          actionDate: this.actionDate,
        }
      });
      addRecommendationModalRef.afterClosed().subscribe(details => {
        this._quotes.reloadQuoteOverview(this._inspectionId);
        if (details != null) {

          this.selectedQuoteIdChanged(this.selectedQuoteId);
          this.recommmendationID = 1;
        }
      });
    }

  }

  GetBorderColour(value, type: string) {
    //if (type == 'TS') {
    //  if (this.hasCRoller) {
    //    let info = this.observationInfo.find(x => x.Title == 'Track Sag with Carrier Roller')
    //    if (info != null && value != '') {
    //      if (value <= info.Max && value >= info.Min) return 'pass';
    //      else if (value > info.Max) return 'fail'
    //      else if (value < info.Min) return 'loose'
    //    } else if (info == null && value != '') return 'notmeasure';
    //    else return '';
    //  } else {
    //    let info = this.observationInfo.find(x => x.Title == 'Track Sag without Carrier Roller')
    //    if (info != null && value != '') {
    //      if (value <= info.Max && value >= info.Min) return 'pass';
    //      else if (value > info.Max) return 'fail'
    //      else if (value < info.Min) return 'loose'
    //    } else if (info == null && value != '') return 'notmeasure';
    //    else return '';
    //  }
    //} else if (type == 'CE') {
    //  let info = this.observationInfo.find(x => x.Title == 'Cannon Extension')
    //  if (info != null && value != '') {
    //    if (value < info.Max) return 'pass';
    //    else return 'fail';
    //  } else if (info == null && value != '') return 'notmeasure';
    //  else return '';

    //} else if (type == 'S') {
    //  let info = this.observationInfo.find(x => x.Title == 'Scallop')
    //  if (info != null && value != '') {
    //    console.log("ddd", info, value, info.Max)
    //    if (value < info.Max) return 'pass';
    //    else return 'fail';
    //  } else if (info == null && value != '') return 'notmeasure';
    //  else return '';
    //}
    //else {
    //  return '';
    //}
    if (value.trim() === '') {
      return '';
    }
    if (type == 'TS') {
      if (this.hasCRoller && this.showCRoller) {
        let info = this.observationInfo.find(x => x.Title == 'Track Sag with Carrier Roller')
        //console.log("Track Sag with Carrier Roller: ", info);
        if (info != null && value != '') {
          if (value <= info.Max && value >= info.Min) return 'pass';
          else if (value > info.Max) return 'loose'
          else if (value < info.Min) return 'fail'
        } else if (info == null && value != '') return 'notmeasure';
        else return '';
      } else {
        let info = this.observationInfo.find(x => x.Title == 'Track Sag without Carrier Roller')
        //console.log("Track Sag without Carrier Roller: ", info);
        if (info != null && value != '') {
          if (value <= info.Max && value >= info.Min) return 'pass';
          else if (value > info.Max) return 'loose'
          else if (value < info.Min) return 'fail'
        } else if (info == null && value != '') return 'notmeasure';
        else return '';
      }
    } else if (type == 'CE') {
      let info = this.observationInfo.find(x => x.Title == 'Cannon Extension')
      if (info != null && value != '') {
        if (value < info.Max) return 'pass';
        else return 'fail';
      } else if (info == null && value != '') return 'notmeasure';
      else return '';

    } else if (type == 'S') {
      let info = this.observationInfo.find(x => x.Title == 'Scallop')
      if (info != null && value != '') {
        //console.log("ddd", info, value, info.Max)
        if (value < info.Max) return 'pass';
        else return 'fail';
      } else if (info == null && value != '') return 'notmeasure';
      else return '';
    }
    else {
      return '';
    }
  }

  visibility(type: string) {
    if (type == 'TS') {
      let hasdata = this.observationInfo.find(x => x.Title == 'Track Sag with Carrier Roller');
      if (this.hasCRoller == true && this.showCRoller == true && hasdata != null) {
        if (hasdata == null && this.observationInfo.length > 0) return false
        else return true;
      } else {
        let hasdata = this.observationInfo.find(x => x.Title == 'Track Sag without Carrier Roller');
        if (hasdata == null && this.observationInfo.length > 0) return false
        else return true;
      }
    } else if (type == 'CE') {
      let hasdata = this.observationInfo.find(x => x.Title == 'Cannon Extension');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;

    } else if (type == 'S') {
      let hasdata = this.observationInfo.find(x => x.Title == 'Scallop');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;

    } else if (type == 'DJ') {
      let hasdata = this.observationInfo.find(x => x.Title == 'Dry Joints');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;

    } else if (type == 'L') {
      let hasdata = this.observationInfo.find(x => x.Title == '# of Links');
      if (hasdata == null && this.observationInfo.length > 0) return false
      else return true;
    }
  }

  flaggedComponents: ComponentFlaggedVM[];
  LoadFlaggedComponents() {
    this._interp.getFlaggedComponentInfo(this._inspectionId).subscribe(res => {
      this.flaggedComponents = res;
    })
  }

  RecordAction() {

    if (this.recordActionDate == undefined || this.recordActionDate == null) {
      this._notify.error('Error', 'Please select Action Date and SMU');
    }
    else if (this.recordActionSMU == undefined || this.recordActionSMU == 0) {
      this._notify.error('Error', 'Please enter Action SMU');
    }
    else {
      if (this.flaggedComponents.length > 0) {
        this.savingForm = true;
        this.flaggedComponents.forEach(x => {
          //console.log('flaggedComponents: ' , x);
          let params = new GeneralActionViewModel();
          params.Comment = x.Comment;//this.ActionComment;
          params.EquipmentId = Number(this.equipmentID);
          params.MakeId = x.MakeId;
          params.NewSMU = this.recordActionSMU;
          params.ReplaceComponentCompartId = x.CompartId;
          params.ActionDate = this.recordActionDate;
          params.ActionEqUnitId = x.ComponentId;
          //params.ActionTypeId = x.SelectedActionTypeId;
          params.BudgetLife = 0;
          params.MiscCost = 0;
          params.NewEqUnitId = 2;
          params.ReplaceComponentCompartName = x.Description;
          params.UsedWorn = 0;
          params.UsedCMU = 0;
          //params.Measurement = x.ActionReading;
          //params.ToolId = x.ActionToolId;
          params.ActionWO = '';
          params.ShoeSize = x.ShoeSizesId
          //params.GrouserId = x.GrouserId
          params.CleanerHolesId = x.ShoeCleanerHoleId
          //console.log("params: ", params);
          //   this.PerformActionForIndivual(params,x);
          if (x.CompTypeId == 230) params.ActionTypeId = 10900;
          else if (x.CompTypeId == 231) params.ActionTypeId = 10201;
          else if (x.CompTypeId == 232) params.ActionTypeId = 10301;
          else if (x.CompTypeId == 233) params.ActionTypeId = 10401;
          else if (x.CompTypeId == 234) params.ActionTypeId = 10601;
          else if (x.CompTypeId == 235) params.ActionTypeId = 10701;
          else if (x.CompTypeId == 236) params.ActionTypeId = 10501;
          else if (x.CompTypeId == 237) params.ActionTypeId = 10801;
          else if (x.CompTypeId == 240) params.ActionTypeId = 10101;
          else if (x.CompTypeId == 446) params.ActionTypeId = 10804;
          else if (x.CompTypeId == 417) params.ActionTypeId = 10803;
          this._actionService.PerformActionForFlaggedComponent(params).subscribe(res => {
            if (res.OperationSucceed) {
              this._notify.success('Operation Succeeded!', 'Action recorded successfully.');
            }
            else {
              this._notify.error('Error', 'Error while reconding action! Please refresh hthe page and try again.');
            }
            this.savingForm = false;
            this._interp.setFlaggedComponentActionTaken(this._inspectionId, x.Id, true, true).subscribe(res => {
              this.reloadFlaggedComponents();
            })
            //window.location.reload();
          })


        });// end flaggedComponents.forEach


        //const perfomrAction = this.flaggedComponents.map(async x => {
        //  let params = new GeneralActionViewModel();
        //  params.Comment = x.Comment;//this.ActionComment;
        //  params.EquipmentId = Number(this.equipmentID);
        //  params.MakeId = x.MakeId;
        //  params.NewSMU = this.recordActionSMU;
        //  params.ReplaceComponentCompartId = x.CompartId;
        //  params.ActionDate = this.recordActionDate;
        //  params.ActionEqUnitId = x.ComponentId;
        //  //params.ActionTypeId = x.SelectedActionTypeId;
        //  params.BudgetLife = 0;
        //  params.MiscCost = 0;
        //  params.NewEqUnitId = 2;
        //  params.ReplaceComponentCompartName = x.Description;
        //  params.UsedWorn = 0;
        //  params.UsedCMU = 0;
        //  //params.Measurement = x.ActionReading;
        //  //params.ToolId = x.ActionToolId;
        //  params.ActionWO = '';
        //  params.ShoeSize = x.ShoeSizesId
        //  //params.GrouserId = x.GrouserId
        //  params.CleanerHolesId = x.ShoeCleanerHoleId
        //  console.log("params: ", params);
        //  //   this.PerformActionForIndivual(params,x);
        //  if (x.CompTypeId == 230) params.ActionTypeId == 10900;
        //  else if (x.CompTypeId == 231) params.ActionTypeId = 10201;
        //  else if (x.CompTypeId == 232) params.ActionTypeId = 10301;
        //  else if (x.CompTypeId == 233) params.ActionTypeId = 10401;
        //  else if (x.CompTypeId == 234) params.ActionTypeId = 10601;
        //  else if (x.CompTypeId == 235) params.ActionTypeId = 10701;
        //  else if (x.CompTypeId == 236) params.ActionTypeId = 10501;
        //  else if (x.CompTypeId == 237) params.ActionTypeId = 10801;
        //  else if (x.CompTypeId == 240) params.ActionTypeId = 10101;
        //  else if (x.CompTypeId == 446) params.ActionTypeId = 10804;
        //  else if (x.CompTypeId == 417) params.ActionTypeId = 10803;
        //  const response = await this._actionService.PerformActionForFlaggedComponent(params).toPromise();
        //  // if (response.OperationSucceed == false) {
        //  //   x.ActionSucess = 2;

        //  // } else if (response.OperationSucceed == true) {
        //  //   x.ActionSucess = 1;

        //  // }
        //  this._interp.setFlaggedComponentActionTaken(this._inspectionId, x.Id, true)
        //  return response;
        //})

      }
    }
  }

  reloadFlaggedComponents() {
    this.LoadFlaggedComponents();
  }
  //ngOnChanges() {
  //  this.isParentChanged = !this.isParentChanged;
  //}

  RemoveRecord(index: number, flaggedComponentId: number) {
    // Remove the component at the specified index from the flaggedComponents array
    //this.flaggedComponents.splice(index, 1);
    this._interp.setFlaggedComponentActionTaken(this._inspectionId, flaggedComponentId, true, false).subscribe(res => {
      if (res) {
        //this.ReloadPage();
        this.LoadFlaggedComponents();
        this.isParentChanged = true;
        //window.location.reload();
      }
    })
  }

  calculateReversePer(totalDistance: number, reverseTravelKM: number) {
    if (totalDistance == 0)
      return 0;
    else
      return ((reverseTravelKM / totalDistance) * 100).toFixed(0);
  }
  copyInspection: CopyInspection = new CopyInspection();
  equipmentIDCopy: number
  Flag: number = 1;
  UpdateLink() {
    this.copyInspection.InspectionId = this._inspectionId;
    this._interp.UpdateLinkForDuplicateInspection(this.copyInspection).subscribe(result => {
      if (result.Status == 1) {
        this.IspopupOpen = false;
        this._notify.success(result.Message)
      } else {
        this._notify.warn(result.Message)
      }
    })

  }
  selectedEquipment: number;
  IspopupOpen1: boolean;
  Data: ComponentComparison[] = [];
  createLink() {
    this.copyInspection.InspectionId = this._inspectionId;
    this.copyInspection.EquipmentIdCopyTo = this.selectedEquipment;
    this.copyInspection.Flag = 1;
    this._interp.CreateLinkForDuplicateInspection(this.copyInspection).subscribe(result => {
      if (result.Status == 1) {

        this._notify.success(result.Message)
      } else if (result.Status == 2) {
        this.IspopupOpen1 = true;
        this.Data = result.Data;
        this._notify.warn(result.Message)
      } else {
        this._notify.warn(result.Message)

      }
      this.IspopupOpen = false;
    })
  }
  HasLinkedInspection: boolean = false;

  CheckInspection() {
    this.HasLinkedInspection = false;
    this._interp.CheckInspection(this._inspectionId).subscribe(result => {
      this.HasLinkedInspection = result;
      if (this.HasLinkedInspection) {
        this.LOadParentsChildInfoInspection();
      } else {
        this.LOadChildsParentInfoInspection();

      }
    })
  }

  ParentInspectionResponse: ParentInspectionResponse = new ParentInspectionResponse();
  ParentInspection: ParentInspection = new ParentInspection();
  IsParent: boolean
  IsChild: boolean
  ChildInspection: ParentInspection = new ParentInspection();

  LOadParentsChildInfoInspection() {
    this.IsChild = false;
    this.HasLinkedInspection = false;
    this.ParentInspectionResponse.Data = new ParentInspection();
    this._interp.ParentsChildEquipment(this._inspectionId).subscribe(result => {
      if (result.Status == 1) {
        this.ParentInspection = result.Data;
        if (this.ParentInspection) {
          this.IsChild = true;
        }
      }
    })
  }
  isJobRoleDefault: boolean = true;
  isAdministrator: boolean = false;
  LoadJobRoles() {
    this._user.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Inspectors':
            this.isJobRoleDefault = false;
            break;
          case 'Interpreters':
            this.isJobRoleDefault = false;
            break;
          case 'Super User':
            this.isJobRoleDefault = false;
            break;
          case 'Administrator':
            this.isJobRoleDefault = false;
            this.isAdministrator = true;

            break;
          case 'Customer Admin':
            this.isJobRoleDefault = false;
            break;
        }
      });

    })
  }
  PermissionMneuData: jobRolePermissions;
  menuL1: MenuListVM[] = [];
  menuL2: MenuListVM[] = [];
  menuL3: MenuListVM[] = [];
  getMenuforSelectedJobrole() {
    this._user.GETMenuForSlectedJobRole(2).subscribe(r => {
      this.PermissionMneuData = r;
      this.menuL3 = this.PermissionMneuData.Menu_L3;
    })
  }

  LOadChildsParentInfoInspection() {
    this.IsParent = false;
    // this.HasLinkedInspection=false;
    this.ParentInspectionResponse.Data = new ParentInspection();
    this._interp.ChildsParentEquipment(this._inspectionId).subscribe(result => {
      if (result.Status == 1) {
        this.ChildInspection = result.Data;
        if (this.ChildInspection) {
          this.IsParent = true;
        }
      }
    })
  }
  EquipmentModels: EquipmentModelNew[];
  GetEquipment() {
    this._appService.getEquipmentByCustomerJobsiteModel(this.CustomerId, this.JobsiteId, this.ModelId).subscribe(result => {
      this.EquipmentModels = result;
    });
  }
  RemoveLink() {
    this._interp.RemoveLink(this._inspectionId).subscribe(result => {
      if (result.Status == 1) {
        this._notify.success(result.Message);
      }
    })
  }
  closePopupSource() {
    this.IspopupOpen1 = false;
  }

  OpenRecommendationPage() {
    window.open('/equipment-action-recommendation/' + this.equipmentID, '_blank');
  }

  // Add or update inspector
  addUpdateAddiInspector(
    id: number,
    name: string,
    overviewModel?: InterpretationOverviewModel
  ) {
    if (!name?.trim()) return;

    const model = overviewModel || this.overviewModel;
    const trimmedName = name.trim();

    const existingInspector = model.AdditionalInspectors.find(ins => ins.Id === id);

    // 🔁 DUPLICATE NAME → rollback
    const duplicate = model.AdditionalInspectors.some(
      ins =>
        ins.InspectorName?.toLowerCase() === trimmedName.toLowerCase() &&
        ins.Id !== id
    );

    if (duplicate) {
      this._notify.warn("This inspector already exists in the list.");

      if (existingInspector) {
        existingInspector.InspectorName = existingInspector.originalName;
        existingInspector.editing = false;
      }
      return;
    }

    // 🟡 NO CHANGE → rollback editing mode only
    if (
      id > 0 &&
      existingInspector &&
      existingInspector.originalName?.trim().toLowerCase() ===
      trimmedName.toLowerCase()
    ) {
      existingInspector.InspectorName = existingInspector.originalName;
      existingInspector.editing = false;
      return;
    }

    const inspectorObj: AddiInspectorsOverviewModel = {
      Id: id,
      InspectionAuto: model.InspectionId,
      InspectorName: trimmedName,
      IsDeleted: false,
      editing: false,
      originalName: ''
    };

    this._interp.manageInterpretationAddiInspector(inspectorObj).subscribe({
      next: (updatedList) => {
        model.AdditionalInspectors = updatedList;

        if (id === 0) {
          model.newAddiInspector = '';
          this._notify.success("Inspector added successfully.");
        } else {
          this._notify.success("Inspector updated successfully.");
        }
      },
      error: (err) => {
        console.error('Error adding/updating inspector:', err);

        // 🔁 API failure → rollback
        if (existingInspector) {
          existingInspector.InspectorName = existingInspector.originalName;
          existingInspector.editing = false;
        }

        this._notify.error("Error while saving data.");
      }
    });
  }



  // Remove inspector
  removeAddiInspector(id: number, overviewModel: InterpretationOverviewModel) {
    if (!id || id <= 0) {
      // Remove locally for unsaved item
      overviewModel.AdditionalInspectors = overviewModel.AdditionalInspectors.filter(ins => ins.Id !== id);
      return;
    }

    const deleteInspector: AddiInspectorsOverviewModel = {
      Id: id,
      InspectionAuto: overviewModel.InspectionId,
      InspectorName: '', // not required for delete
      IsDeleted: true,
      editing: false,
      originalName: ''
    };

    this._interp.manageInterpretationAddiInspector(deleteInspector).subscribe({
      next: (updatedList) => {
        overviewModel.AdditionalInspectors = updatedList;
        this._notify.success("Inspector deleted successfuly.");
      },
      error: (err) => {
        console.error('Error deleting inspector:', err);
        this._notify.error("Error while deleting data.");
      }
    });
  }

  startEditing(ins: any) {
    ins.originalName = ins.InspectorName;
    ins.editing = true;
  }

  finishEditing(ins: any, overviewModel?: InterpretationOverviewModel) {
    this.addUpdateAddiInspector(ins.Id, ins.InspectorName, overviewModel);
  }

  openSummaryNotes() {
      const summaryNotes = this._dialog.open(EquipmentNotesHistoryComponent, {
          width: '1200px',
          maxWidth: '95vw',
          autoFocus: false,
          restoreFocus: false,
          disableClose: true,
          data: {
            EquipmentId: this.overviewModel.Equipment.EquipmentId,
            Title: "Equipment Summary Notes",
            HistoryTitle: "Summary Notes History",
            SummaryNotesExists: this.overviewModel.Equipment.SummaryNotesExists,
            ScreenId: 15
          }
      });
      summaryNotes.afterClosed().subscribe(details => {
      });
    }

  getInspectionLocations(): void {
    this.inspectionLocations = [];
    this._interp.getInspectionLocations().subscribe(
        (response: InspectionLocationVM[]) => {
          this.inspectionLocations = response || [];
        },
        (error) => {
          console.error('Error loading inspection locations', error);
          this.inspectionLocations = [];
        }
      );
  }
    
  onInspectionLocationChange(locationId: number): void {
    
    this._interp.updateInspectionLocation(this._inspectionId, locationId).subscribe(
      (response: boolean) => {
        if (response) {
          this._notify.success('Inspection location updated successfully.');
        } else {
          this._notify.error('Failed to update inspection location.');
        }
      },
      (error) => {
        this._notify.error('Error updating inspection location.', error);
      }
    );
  }


}


//openRecommendation() {
//  alert('checkboolean value');
//}
